
import React, { useState } from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Bell, RefreshCw, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import ProtectedRoute from '@/components/ProtectedRoute';
import UserNotifications from '@/components/UserNotifications';
import CreateNotification from '@/components/admin/CreateNotification';
import OneSignalNotificationForm from '@/components/admin/OneSignalNotificationForm';

const Notifications = () => {
  return (
    <ProtectedRoute requireAdmin={true}>
      <Layout>
        <div className="container mx-auto px-4 py-8">
          <div className="mb-8 flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-vegana-primary mb-2">
                Gestionar Notificaciones
              </h1>
              <p className="text-gray-600">
                Envía notificaciones in-app y push con OneSignal, programa recordatorios nutricionales
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <CreateNotification />
            <OneSignalNotificationForm />
          </div>
          
          <div className="grid grid-cols-1 gap-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Bell className="text-vegana-primary" />
                  Historial de Notificaciones
                </CardTitle>
                <CardDescription>
                  Notificaciones enviadas recientemente
                </CardDescription>
              </CardHeader>
              <CardContent>
                <UserNotifications />
              </CardContent>
            </Card>
          </div>
        </div>
      </Layout>
    </ProtectedRoute>
  );
};

export default Notifications;
